import store from '@/store';
export default {
  height: "auto",
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 5,
  searchMenuSpan: 4,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchLabelWidth: 100,
  column: [
    {
      label: "主键id",
      prop: "id",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "进件编号",
      prop: "businessCode",
      type: "input",
      search: true,
      searchOrder: 995,
    },
    {
      label: "所属代理商",
      prop: "businessDeptName",
      type: "input",
    },
    {
      label: "产品类型",
      prop: "rentType",
      type: "select",
      dicData: store.getters.porductTypes
    },
    {
      label: "产品类型",
      prop: "rentTypeList",
      type: "select",
      search: true,
      searchMultiple: true,
      searchOrder: 999,
      hide: true,
      showColumn: false,
      dicData: store.getters.porductTypes
    },
    {
      label: "租赁人",
      prop: "name",
      type: "input",
      search: true,
      searchOrder: 998,
    },
    {
      label: "手机号",
      prop: "phoneNumber",
      type: "input",
    },
    {
      label: "车牌号",
      prop: "carFirstNumber",
      type: "input",
      searchOrder: 997,
      search: true,
    },
    {
      label: "年检到期",
      prop: "carInspectionEndDate",
      type: "date",
      search: true,
      searchOrder: 996,
      searchRange: true,
      searchType: "daterange",
      valueFormat: "yyyy-MM-dd",
    },
    {
      label: "所属代理商",
      prop: "businessDeptIdList",
      type: "select",
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: "title",
        value: "id",
      },
    },
    {
      label: "违章计分",
      prop: "violationScore",
      type: "input",
      slot: true,
      formatter: (val, value, label) => {
        return value === 0 ? '' : value;
      },
    },
    {
      label: "违章罚款",
      prop: "violationFinesAmount",
      type: "input",
      formatter: (val, value, label) => {
        return !value ? '' : (value + '元');
      },
    }
  ]
};
